export function positionFloatingElement(triggerEl, floatingEl, placement = 'top', gap = 8) {
  const trigger = triggerEl.getBoundingClientRect()
  const floating = floatingEl.getBoundingClientRect()
  let top, left

  switch (placement) {
    case 'right':
      top = trigger.top + trigger.height / 2 - floating.height / 2
      left = trigger.right + gap
      break
    case 'left':
      top = trigger.top + trigger.height / 2 - floating.height / 2
      left = trigger.left - floating.width - gap
      break
    case 'bottom':
      top = trigger.bottom + gap
      left = trigger.left + trigger.width / 2 - floating.width / 2
      break
    case 'top':
    default:
      top = trigger.top - floating.height - gap
      left = trigger.left + trigger.width / 2 - floating.width / 2
  }

  floatingEl.style.position = 'fixed'
  floatingEl.style.top = `${top}px`
  floatingEl.style.left = `${left}px`
}
